import { Component, OnInit } from '@angular/core';
import { Partner } from '../../../models/partner.model';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css']
})
export class PartnersComponent implements OnInit {
  partners: Partner[];
  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.getPartner();
  }

  getPartner() {
    this.partners = this.dataService.getPartner();
  }

}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/components/home/partners/partners.component.ts